export default "__VITE_ASSET__JT9R7TN0__"